import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { NgBusyService } from '@nakedcreativity/ng-busy';
import { finalize } from 'rxjs/operators';


@Injectable()
export class TokenInterceptor implements HttpInterceptor {
  constructor(private busyService: NgBusyService) {}
  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    
    this.busyService.busy()
    request = request.clone({
      setHeaders: {
        Authorization: localStorage.getItem('membrs')
      }
    });
    return next.handle(request).pipe(finalize(()=>{
      this.busyService.finished()
    }));
  }
}